// import clickTrackingSuite from './click-tracking';

export function parseProductArrayToString(productArray) {
    if (productArray.length) {
        return (productArray || []).join(',;').replace(/^/, 'D2C;');
    }
    return '';
}

export function convertGender(gender) {
    return {
        1: 'M',
        2: 'F'
    }[gender] || 'not set';
}

export function buildPageLevelTrackingProductString(pageToShow) {
    const product = [];
    const buttons = $(pageToShow).find('.cta-button');
    for (let i = 0; i < buttons.length; i++) {
        const trackingObject = $(buttons[i]).data('tracking');
        if (trackingObject && trackingObject.products) {
            for (let j = 0; j < trackingObject.products.length; j++) {
                if (!product.includes(trackingObject.products[j])) {
                    product.push(trackingObject.products[j]);
                }
            }
        }
    }
    return parseProductArrayToString(product);
}

export function setTrackingProductCode($pageToShow) {
    window.espnTrackingConfig = window.espnTrackingConfig || {};
    window.espnTrackingConfig.delayedValues = window.espnTrackingConfig.delayedValues || {};
    window.espnTrackingConfig.delayedValues.product = buildPageLevelTrackingProductString($pageToShow);
}
